import React, { useEffect, useState } from "react";
import styles from "./InternalApproval.module.scss";
import InputField from "../../../../reusable-components/TNInputField";
import { InputfieldTypes } from "../../../../enums/InputFieldAttributesEnums";
import { enumToLabelValueArray } from "../../../../utils/getDropdownOptions";
import {
  DROPDOWN1,
  DROPDOWN2,
  DROPDOWN3,
} from "../../../../enums/InternalApproval";
import {
  Row,
  Col,
  Modal,
  message,
  Tag,
  Popover,
} from "antd";
import RadioComponent from "../../../../reusable-components/RadioComponent";
import TNButton from "../../../../reusable-components/TNButton";
import {
  ButtonType,
  ButtonShape,
} from "../../../../enums/ButtonAttributesEnums";
import TNGoogleAddressSuggestions from "../../../../reusable-components/TNGoogleSearch";
import ProjectInformationSheetProofUpload from "../JobLead/ProjectInformationSheetProofUpload";
import ConditionalRender from "../../../../reusable-components/ConditionalRender";
import InternalApprovalUploadDragger from "./InternalApprovalUploadDragger";
import pdfIcon from "../../../../assets/images/pdf-icon-red.svg";
import fileIcon from "../../../../assets/images/default_file.svg";
import popOverIcon from "../../../../assets/images/reject-reason-popover.svg";
import deleteIcon from "../../../../assets/images/delete-icon.svg";
import CreateJobServices from "../../../../services/createJob.services";
import { UploadDocType } from "../JobLead/constants";
import clsx from "clsx";
import { useFormContext } from "react-hook-form";
import {
  ApprovalStatus,
  ImageAltText,
  ButtonTitles,
  BondStatusLabel,
  BondStatusValue,
  internalApprovalInputFields,
  onSiteContactFields,
  projectCoordinateFields,
  internalApprovalHeaders,
  noDocumentFoundMessages,
  taxExemptStatusValue,
  modalHeaders,
  taxExemptRadioOptions,
  InteralApprovalPageConstants,
  invoiceNotesFields,
  internalApprovalBeforeStates,
  fileTypePermissions,
} from "./constants";
import { ApprovalColorCode } from "../../../../enums/DocumentsApprovalColorEnums";
import { SectionStatus } from "../../../../enums/SubSectionStatus";
import { DocTypes } from "../../../../enums/DocTypes";
import { useLocation } from "react-router-dom";
import CustomRenderSelectField from "../../../../reusable-components/CustomerRenderSelectField";
import { InternalApprovalMessages, inputFieldsName } from "./constants";
import { PlacementPositions } from "../../../../enums/PlacementPositionsEnums";
import { FileTypes } from "../../../../enums/FileUploadEnums";
import { continueButtonEnablingSections, createJobCommonConstants, jobStatus } from "../constants";
import { formatPhoneNumber } from "../../../../utils/numberFormatterUtil";
import jpgIcon from "../../../../assets/images/jpeg-image-icon.svg";
import pngIcon from "../../../../assets/images/png-image-icon.svg";
import excelIcon from "../../../../assets/images/excel-file-icon.svg";
import csvIcon from "../../../../assets/images/csvIcon.svg";
import docIcon from "../../../../assets/images/docIcon.svg";
import { showConfirmModal } from "../../../../utils/popupModalUtils";

const InternalApproval = ({
  jobLeadId,
  handleInternalApprovalFiles,
  handleCashOrCreditFiles,
  editable,
  taxExempt,
  setTaxExempt,
  setContinueDisabled,
}) => {
  const iconMapping = {
    [FileTypes.PDF]: pdfIcon,
    [FileTypes.CSV]: csvIcon,
    [FileTypes.XLS]: excelIcon,
    [FileTypes.XLSX]: excelIcon,
    [FileTypes.DOC]: docIcon,
    [FileTypes.DOCX]: docIcon,
    [FileTypes.PNG]: pngIcon,
    [FileTypes.JPEG]: jpgIcon,
    [FileTypes.JPG]: jpgIcon,
  };
  const location = useLocation();
  const leadId = editable ? location?.pathname?.split("/")?.at(-1) : jobLeadId;
  const { pdfAltText } = ImageAltText;
  const { uploadButtonTitle } = ButtonTitles;
  const { jobSiteAddress, jobSiteAddressCoordinates, cashOrCreditSale } =
    internalApprovalInputFields;
  const { setValue, getValues, trigger, clearErrors, watch } = useFormContext();
  const dropdown1Options = enumToLabelValueArray(DROPDOWN1);
  const dropdown2Options = enumToLabelValueArray(DROPDOWN2);
  const dropdown3Options = enumToLabelValueArray(DROPDOWN3);
  const {
    projectBondStatusHeader,
    projectCoordinatesHeader,
    projectDetailsHeader,
    onSiteContactHeader,
    customerApprovalAggrementHeader,
    taxExemptDocumentHeader,
    overallProjectInformationSheetHeader,
    cashOrCreditSaleHeader,
    invoiceNotesHeader,
    invoiceNotesSubHeader,
    warningContent,
  } = internalApprovalHeaders;
  const {
    taxExemptModalHeader,
    bondInfoModalHeader,
    projectBondHeader,
    projectInfoSectionHeader,
    projectInformationSheetHeader,
    propertyLegalDescriptionHeader,
    propertyOwnerInformationHeader,
    subContractorOwnerHeader,
    generalOwnerInformationHeader,
  } = modalHeaders;
  const { noProjectInformationSheet, noTaxExemptDocument } =
    noDocumentFoundMessages;
  const {
    removeConfirmationContent,
    removeFileConfirmationTitle,
  } = createJobCommonConstants;
  const {
    PROJECT_BOND_STATUS_SUBHEADING
  } = InteralApprovalPageConstants
  const { projectBondButton, taxExemptButton } = inputFieldsName;
  const subSections = [
    "Project Info Section",
    "Property Legal Description",
    "Property Owner Information",
    "General Contractor Information",
    "Subcontractor Information",
    "Bond Information",
  ];

  const dropdown1Value = getValues("dropdown1");
  const dropdown2Value = getValues("dropdown2");
  const dropdown3Value = getValues("dropdown3");

  const dropdown1DefaultValues = Object.values(DROPDOWN1);
  const dropdown2DefaultValues = Object.values(DROPDOWN2);
  const dropdown3DefaultValues = Object.values(DROPDOWN3);

  const _drop1Items = dropdown1DefaultValues.includes(dropdown1Value)
    ? dropdown1DefaultValues
    : [...dropdown1DefaultValues, dropdown1Value].filter(Boolean);
  const _drop2Items = dropdown2DefaultValues.includes(dropdown2Value)
    ? dropdown2DefaultValues
    : [...dropdown2DefaultValues, dropdown2Value].filter(Boolean);
  const _drop3Items = dropdown3DefaultValues.includes(dropdown3Value)
    ? dropdown3DefaultValues
    : [...dropdown3DefaultValues, dropdown3Value].filter(Boolean);

  const [dropDown1Items, setDropDown1Items] = useState(_drop1Items);
  const [dropDown2Items, setDropDown2Items] = useState(_drop2Items);
  const [dropDown3Items, setDropDown3Items] = useState(_drop3Items);

  const [dropDown1InputName, setDropDown1InputName] = useState("");
  const [dropDown2InputName, setDropDown2InputName] = useState("");
  const [dropDown3InputName, setDropDown3InputName] = useState("");

  const [bondStatus, setBondStatus] = useState(
    Object.values(BondStatusValue)?.includes(getValues(projectBondButton))
      ? getValues(projectBondButton)
      : () => {
          setValue(projectBondButton, BondStatusValue.notBonded);
          return BondStatusValue.notBonded;
        }
  );
  
  const retainDocumentAction = async (docData, docType) => {
    const documentData = [docData];
    if(docType === DocTypes.BOND_INFO_DOCUMENT) {
      setBondInfoDocumentFiles(documentData);
    }
    if (docType === DocTypes.TAX_EXEMPT_CERTIFICATE) {
      setTaxExemptDocumentFiles(documentData);
    }
  }

  const handleBondRadioChange = (value) => {
    setValue(projectBondButton, value);
    setBondStatus(value);
  }

  const handleBondStatusChange = (value) => {
    if(
      value === BondStatusValue.notBonded
      && bondInfoDocumentFiles?.length > 0
    ) {
      const bondDoc = {
        ...bondInfoDocumentFiles?.[0],
        docType: DocTypes.DEPRECATED_BOND_INFO_DOCUMENT,
        document: DocTypes.DEPRECATED_BOND_INFO_DOCUMENT,
      }
      showConfirmModal({
        docType: DocTypes.BOND_INFO_DOCUMENT,
        title: removeFileConfirmationTitle(DocTypes.BOND_INFO_DOCUMENT),
        content: removeConfirmationContent,
        //Retain
        onOk: () => {
          handleBondRadioChange(value);
          retainDocumentAction(bondDoc, DocTypes.BOND_INFO_DOCUMENT);
        },
        //Remove
        onCancel: () => {
          setBondInfoDocumentFiles([]);
          handleBondRadioChange(value);
        },
      });
      return;
    } else {
      if (bondInfoDocumentFiles?.length > 0) {
        const bondDoc = {
          ...bondInfoDocumentFiles?.[0],
          docType: DocTypes.BOND_INFO_DOCUMENT,
          document: DocTypes.BOND_INFO_DOCUMENT,
        }
        setBondInfoDocumentFiles([bondDoc]);
      }
      handleBondRadioChange(value);
    }
  };

  const handleTaxStatusChange = (value) => {
    if(
      value === taxExemptStatusValue.notExempt
      && taxExemptDocumentFiles?.length > 0
    ) {
      const taxDoc = {
        ...taxExemptDocumentFiles?.[0],
        docType: DocTypes.DEPRECATED_TAX_EXEMPT_CERTIFICATE,
        document: DocTypes.DEPRECATED_TAX_EXEMPT_CERTIFICATE,
      }
      showConfirmModal({
        docType: DocTypes.TAX_EXEMPT_CERTIFICATE,
        title: removeFileConfirmationTitle(DocTypes.TAX_EXEMPT_CERTIFICATE),
        content: removeConfirmationContent,
        //Retain
        onOk: () => {
          setTaxExempt(value);
          retainDocumentAction(taxDoc, DocTypes.TAX_EXEMPT_CERTIFICATE);
        },
        //Remove
        onCancel: () => {
          setTaxExemptDocumentFiles([]);
          setTaxExempt(value);
        },
      });
      return;
    } else {
      if (taxExemptDocumentFiles?.length > 0) {
         const taxDoc = {
          ...taxExemptDocumentFiles?.[0],
          docType: DocTypes.TAX_EXEMPT_CERTIFICATE,
          document: DocTypes.TAX_EXEMPT_CERTIFICATE,
        }
        setTaxExemptDocumentFiles([taxDoc]);
      }
      setTaxExempt(value);
    }
  };
  const [isProjectBondUploadModalOpen, setIsProjectBondUploadModalOpen] =
    useState(false);
  const handleProjectBondUploadModalOpen = () => {
    setIsProjectBondUploadModalOpen(true);
  };
  const handleProjectBondUploadModalClose = () => {
    setIsProjectBondUploadModalOpen(false);
  };
  const [projectBondFiles, setProjectBondFiles] = useState([]);
  const handleProjectBondFileChange = (files) => {
    setProjectBondFiles(files);
  };
  const [cashOrCreditDocs, setCashOrCreditDocs] = useState([]);
  const handleCashOrCreditFileChange = (files) => {
    setCashOrCreditDocs(files);
  };
  const {
    FetchAllDocuments,
    FetchSelectedJob,
    DeleteDocuments,
    GetLocationFromCoordinates,
  } = CreateJobServices();
  const cashOrCreditStatus = watch(cashOrCreditSale);
  const coords = watch("jobSiteAddressCoordinates");
  const [locLat, locLng] = coords?.split(",");
  const { data: locationData } = GetLocationFromCoordinates({
    lat: locLat?.trim(),
    lon: locLng?.trim(),
  });

  const { mutateAsync: deleteDocument, isPending: isDeletingDocument } =
    DeleteDocuments();
  const handleDeleteDocument = async (documentId?: string) => {
    const payload = {
      recordIds: [documentId],
      leadId,
    };
    const data = await deleteDocument(payload);
  };
  const { data: documentsData, refetch: refecthDocuments } =
    FetchAllDocuments(leadId);
  const filteredDocuments = documentsData
    ?.filter((doc) => doc.signatureVerified)
    ?.map((doc) => ({
      ...doc,
      name: doc.name || doc.docAttachmentId.replace("quotes/", ""),
    }));
  const projectInformationSheet = documentsData?.filter(
    (doc) => doc?.docType === UploadDocType.projectDoc
  );
  const [projectInformationSheetFiles, setProjectInformationSheetFiles] =
    useState([]);
  const [
    isProjectInformationSheetModalOpen,
    setIsProjectInformationSheetModalOpen,
  ] = useState(false);
  const handleProjectInformationSheetModalOpen = () => {
    setIsProjectInformationSheetModalOpen(true);
  };
  const handleProjectInformationSheetModalClose = () => {
    setIsProjectInformationSheetModalOpen(false);
  };
  const taxExemptDocument = documentsData?.find(
    (doc) => doc?.docType === UploadDocType.taxDoc
  );
  const [taxExemptDocumentFiles, setTaxExemptDocumentFiles] = useState([]);
  const [isTaxExemptDocuemntUploadModalOpen, setTaxExemptDocumentModalOpen] =
    useState(false);
  const handleTaxExemptDocumentModalOpen = () =>
    setTaxExemptDocumentModalOpen(true);
  const handleTaxExemptDocumentModalClose = () =>
    setTaxExemptDocumentModalOpen(false);

  //FETCH JOB DETAILS
  const {
    data: jobData,
    refetch: refetchJobDetails,
    isPending: isJobDetailsFetched,
  } = FetchSelectedJob(leadId, leadId && editable);
  let [approvalDocuments, setApprovalDocuments] = useState({
    "Project Info Section": { status: ApprovalStatus.pending },
    "Property Legal Description": { status: ApprovalStatus.pending },
    "Property Owner Information": { status: ApprovalStatus.pending },
    "General Contractor Information": {
      status: ApprovalStatus.pending,
    },
    "Subcontractor Information": { status: ApprovalStatus.pending },
    "Bond Information": { status: ApprovalStatus.pending },
  });

  useEffect(() => {
    if (jobData?.approvalDocuments && !!!jobData?.cashOrCreditSale) {
      setApprovalDocuments(jobData?.approvalDocuments);
    }
    if (!!jobData?.jobSite) {
      // Subsequent Entries to Internal Approval
      setValue(jobSiteAddress, jobData?.jobSite);
      trigger(jobSiteAddress);
      setValue(
        jobSiteAddressCoordinates,
        `${jobData?.jobSiteLatLng?.lat}, ${jobData?.jobSiteLatLng?.lng}`
      );
      trigger(jobSiteAddressCoordinates);
      setValue(onSiteContactFields[0].name, jobData?.approvalInfo?.name);
      trigger(onSiteContactFields[0].name);
      if(!!jobData?.approvalInfo?.phone) {
        setValue(onSiteContactFields[1].name, jobData?.approvalInfo?.phone);
        trigger(onSiteContactFields[1].name);
      } else {
        setValue(onSiteContactFields[1].name, "");
      }
      if(!!jobData?.approvalInfo?.email) {
        setValue(onSiteContactFields[2].name, jobData?.approvalInfo?.email);
        trigger(onSiteContactFields[2].name);
      } else {
        setValue(onSiteContactFields[2].name, "");
      }
      setValue(cashOrCreditSale, jobData?.cashOrCreditSale);
    } else if (!!!jobData?.jobSite) {
      // Initial Entry to Internal Approval
      setValue(jobSiteAddress, jobData?.dropoff);
      trigger(jobSiteAddress);
      setValue(
        jobSiteAddressCoordinates,
        `${jobData?.dropOffLatLng?.lat}, ${jobData?.dropOffLatLng?.lng}`
      );
      trigger(jobSiteAddressCoordinates);
      if(!!jobData?.approvalInfo?.name){
        setValue(onSiteContactFields[0].name, jobData?.approvalInfo?.name);
        trigger(onSiteContactFields[0].name);
      } else {
        setValue(onSiteContactFields[0].name, `${jobData?.contactDetails?.[0]?.firstName} ${jobData?.contactDetails?.[0]?.lastName}`);
        trigger(onSiteContactFields[0].name);
      }
      if(!!jobData?.approvalInfo?.phone) {
        setValue(onSiteContactFields[1].name, jobData?.approvalInfo?.phone);
        trigger(onSiteContactFields[1].name);
      } else if(!!jobData?.contactDetails?.[0]?.phone) {
        setValue(onSiteContactFields[1].name, jobData?.contactDetails?.[0]?.phone);
        trigger(onSiteContactFields[1].name);
      } else {
        setValue(onSiteContactFields[1].name, "");
      }
      if(!!jobData?.approvalInfo?.email) {
        setValue(onSiteContactFields[2].name, jobData?.approvalInfo?.email);
        trigger(onSiteContactFields[2].name);
      } else if(!!jobData?.contactDetails?.[0]?.email) {
        setValue(onSiteContactFields[2].name, jobData?.contactDetails?.[0]?.email);
        trigger(onSiteContactFields[2].name);
      } else {
        setValue(onSiteContactFields[2].name, "");
      }
    }
    if (jobData?.taxExempt) {
      setTaxExempt(jobData?.taxExempt);
    }
  }, [jobData]);

  const [selectedRow, setSelectedRow] = useState(0);

  //Project Info Section Upload
  const [projectInfoSectionFiles, setProjectInfoSectionFiles] = useState([]);
  const [
    isProjectInfroSectionUploadModalOpen,
    setIsProjectInfoSectionUploadModalOpen,
  ] = useState(false);

  //Property Legal Description
  const [propertyLegalDescriptionFiles, setPropertyLegalDescriptionFiles] =
    useState([]);
  const [
    isPropertyLegalDescriptionUploadModalOpen,
    setIsPropertyLegalDescriptionUploadModalOpen,
  ] = useState(false);

  //Property Owner Information
  const [propertyOwnerInformationFiles, setPropertyOwnerInformationFiles] =
    useState([]);
  const [
    isPropertyOwnerInformationUploadModalOpen,
    setIsPropertyOwnerInformationUploadModalOpen,
  ] = useState(false);
  //General Contractor Information
  const [
    generalContractorInformationFiles,
    setGeneralContractorInformationFiles,
  ] = useState([]);
  const [
    isGeneralContractorInformationUploadModalOpen,
    setIsGeneralContractorInformationUploadModalOpen,
  ] = useState(false);
  //Subcontractor Information
  const [subcontractorInformationFiles, setSubcontractorInformationFiles] =
    useState([]);
  const [
    isSubcontractorInformationUploadModalOpen,
    setIsSubcontractorInformationUploadModalOpen,
  ] = useState(false);

  const bondInfoDocument = documentsData?.find(
    (doc) => doc?.docType === DocTypes.BOND_INFO_DOCUMENT
  );
  const [bondInfoDocumentFiles, setBondInfoDocumentFiles] = useState([]);
  const [
    isBondInfoDocumentUploadModalOpen,
    setBondInfoDocumentUploadModalOpen,
  ] = useState(false);

  useEffect(() => {
    handleInternalApprovalFiles([
      ...projectInfoSectionFiles,
      ...propertyLegalDescriptionFiles,
      ...propertyOwnerInformationFiles,
      ...subcontractorInformationFiles,
      ...projectBondFiles,
      ...generalContractorInformationFiles,
      ...projectInformationSheetFiles,
      ...bondInfoDocumentFiles,
      ...taxExemptDocumentFiles,
    ]);
  }, [
    projectInfoSectionFiles,
    propertyLegalDescriptionFiles,
    propertyOwnerInformationFiles,
    subcontractorInformationFiles,
    projectBondFiles,
    generalContractorInformationFiles,
    projectInformationSheetFiles,
    bondInfoDocumentFiles,
    taxExemptDocumentFiles,
  ]);
  useEffect(() => {
    handleCashOrCreditFiles([...cashOrCreditDocs]);
  }, [cashOrCreditDocs]);
  useEffect(() => {
    if (documentsData) {
      setProjectInformationSheetFiles(projectInformationSheet ?? []);

      setBondInfoDocumentFiles(bondInfoDocument ? [bondInfoDocument] : []);
      
      setTaxExemptDocumentFiles(taxExemptDocument ? [taxExemptDocument] : []);
    }

    const existingCashOrCreditDocs = documentsData?.filter(
      (doc) => doc?.docType === DocTypes.CASH_CREDIT_SALE_DOCUMENTS
    ) ?? [];
    if (existingCashOrCreditDocs.length > 0) {
      setCashOrCreditDocs(existingCashOrCreditDocs);
    } else {
      setCashOrCreditDocs([]);
    }

    if (
      !approvalDocuments[Object.keys(approvalDocuments)?.[0]]
        ?.documentAttachments ||
      !documentsData ||
      (!editable && !(jobData?.stageId === jobStatus.internalApprovalDraft))
    )
      return;

    const getDocsByIds = (ids) =>
      documentsData.filter((doc) => ids.includes(doc.id));
    setProjectInfoSectionFiles(
      getDocsByIds(
        approvalDocuments["Project Info Section"]?.documentAttachments || []
      )
    );
    setPropertyLegalDescriptionFiles(
      getDocsByIds(
        approvalDocuments["Property Legal Description"]?.documentAttachments ||
          []
      )
    );
    setPropertyOwnerInformationFiles(
      getDocsByIds(
        approvalDocuments["Property Owner Information"]?.documentAttachments ||
          []
      )
    );
    setGeneralContractorInformationFiles(
      getDocsByIds(
        approvalDocuments["General Contractor Information"]
          ?.documentAttachments || []
      )
    );
    setSubcontractorInformationFiles(
      getDocsByIds(
        approvalDocuments["Subcontractor Information"]?.documentAttachments ||
          []
      )
    );
    setProjectBondFiles(
      getDocsByIds(
        approvalDocuments["Bond Information"]?.documentAttachments || []
      )
    );
  }, [documentsData, approvalDocuments]);
  const getOverallApprovalStatus = () => {
    const statuses = Object.values(approvalDocuments).map(
      (section) => section.status
    );
    if (internalApprovalBeforeStates?.includes(jobData?.stageId))
      return SectionStatus.PENDING;
    const hasRejected = statuses.some(
      (status) =>
        status === SectionStatus.L1_REJECTED ||
        status === SectionStatus.L2_REJECTED
    );

    if (hasRejected) return SectionStatus.REJECTED;

    const allApproved = statuses.every(
      (status) =>
        status === SectionStatus.L1_APPROVED ||
        status === SectionStatus.L2_APPROVED
    );
    if (allApproved) return SectionStatus.APPROVED;

    const allPending = statuses.every(
      (status) => status === SectionStatus.PENDING
    );
    if (allPending) return SectionStatus.PENDING;
    return SectionStatus.PENDING;
  };

  useEffect(() => {
    if (
      documentsData &&
      (jobData?.stageId === jobStatus.l2Approved ||
        jobData?.stageId === jobStatus.internalApprovalComplete)
    ) {
      const listOfApprovalFiles = [
        ...projectInfoSectionFiles,
        ...propertyLegalDescriptionFiles,
        ...propertyOwnerInformationFiles,
        ...subcontractorInformationFiles,
        ...projectBondFiles,
        ...generalContractorInformationFiles,
      ];
      const docsIds = new Set(
        documentsData
          ?.filter((doc) => subSections.includes(doc?.docType))
          ?.map((doc) => doc?.id)
      );
      const cashOrCreditDocIds = new Set(
        documentsData
          ?.filter((doc) => doc?.docType === DocTypes.CASH_CREDIT_SALE_DOCUMENTS)
          ?.map((doc) => doc?.id)
      )
      const approvalIds = new Set(listOfApprovalFiles?.map((doc) => doc?.id));
      const cashOrCreditIds = new Set(cashOrCreditDocs?.map((doc) => doc?.id));
      if (docsIds?.size !== approvalIds?.size) {
        setContinueDisabled(true);
        return;
      }
      if (cashOrCreditDocIds?.size !== cashOrCreditIds?.size) {
        setContinueDisabled(true);
        return;
      }
      for (let id of docsIds) {
        if (!approvalIds?.has(id)) {
          setContinueDisabled(true);
          return;
        }
      }

      for (let id of cashOrCreditIds) {
        if (!cashOrCreditDocIds?.has(id)) {
          setContinueDisabled(true);
          return;
        }
      };

      setContinueDisabled(false);
    }
  }, [
    projectInfoSectionFiles,
    propertyLegalDescriptionFiles,
    propertyOwnerInformationFiles,
    subcontractorInformationFiles,
    projectBondFiles,
    generalContractorInformationFiles,
    cashOrCreditDocs
  ]);

  const handleSubSectionDocumentDelete = async (
    file,
    sectionFiles,
    setSectionFiles,
    index
  ) => {
    const updatedFiles = sectionFiles.filter((_, i) => i !== index);
    setSectionFiles(updatedFiles);
  };

  const [lastUploadedFile, setLastUploadedFile] = useState([]);
  const handleOnCancel = (handleModalOpen, sectionFiles, setSectionFiles) => {
    if (Array.isArray(lastUploadedFile) && lastUploadedFile?.length > 0) {
      const uploadedFileIds = new Set(
        lastUploadedFile?.map((file) => file?.docAttachmentId)
      );
      const updatedFiles = sectionFiles?.filter(
        (doc) => !uploadedFileIds.has(doc?.docAttachmentId)
      );
      setSectionFiles(updatedFiles);
      setLastUploadedFile([]);
      message.warn(InternalApprovalMessages.fileUploadCancelled);
    }

    handleModalOpen(false);
    return;
  };
  return (
    <>
      <Modal
        okButtonProps={{
          title: "Upload",
          disabled: !taxExemptDocumentFiles.length,
          onClick: () => {
            handleTaxExemptDocumentModalClose();
            setLastUploadedFile([]);
          },
        }}
        visible={isTaxExemptDocuemntUploadModalOpen}
        onCancel={() => {
          handleOnCancel(
            setTaxExemptDocumentModalOpen,
            taxExemptDocumentFiles,
            setTaxExemptDocumentFiles
          );
        }}
        width={"761px"}
        title={taxExemptModalHeader}
      >
        <InternalApprovalUploadDragger
          handleFileUpload={setTaxExemptDocumentFiles}
          fileType={DocTypes.TAX_EXEMPT_CERTIFICATE}
          listOfUploadedFiles={taxExemptDocumentFiles}
          maxFileSize={1}
          allowedFileTypes={fileTypePermissions}
          handleDeleteDocument={handleDeleteDocument}
          setLastUploadedFile={setLastUploadedFile}
        />
      </Modal>
      <Modal
        okButtonProps={{
          title: "Upload",
          disabled: !bondInfoDocumentFiles.length,
          onClick: () => {
            setBondInfoDocumentUploadModalOpen(false);
            setLastUploadedFile([]);
          },
        }}
        visible={isBondInfoDocumentUploadModalOpen}
        onCancel={() => {
          handleOnCancel(
            setBondInfoDocumentUploadModalOpen,
            bondInfoDocumentFiles,
            setBondInfoDocumentFiles
          );
        }}
        width={"761px"}
        title={bondInfoModalHeader}
      >
        <InternalApprovalUploadDragger
          handleFileUpload={setBondInfoDocumentFiles}
          fileType={DocTypes.BOND_INFO_DOCUMENT}
          listOfUploadedFiles={bondInfoDocumentFiles}
          maxFileSize={1}
          allowedFileTypes={fileTypePermissions}
          handleDeleteDocument={handleDeleteDocument}
          setLastUploadedFile={setLastUploadedFile}
        />
      </Modal>
      <Modal
        okButtonProps={{
          title: "Upload",
          disabled: !projectInformationSheetFiles.length,
          onClick: () => {
            handleProjectInformationSheetModalClose();
            setLastUploadedFile([]);
          },
        }}
        visible={isProjectInformationSheetModalOpen}
        onCancel={() => {
          handleOnCancel(
            setIsProjectInformationSheetModalOpen,
            projectInformationSheetFiles,
            setProjectInformationSheetFiles
          );
        }}
        width={"761px"}
        title={projectInformationSheetHeader}
      >
        <InternalApprovalUploadDragger
          handleFileUpload={setProjectInformationSheetFiles}
          fileType={DocTypes.PROJECT_INFORMATION_SHEET}
          listOfUploadedFiles={projectInformationSheetFiles}
          maxFileSize={1}
          allowedFileTypes={fileTypePermissions}
          handleDeleteDocument={handleDeleteDocument}
          setLastUploadedFile={setLastUploadedFile}
        />
      </Modal>
      <Modal
        okButtonProps={{
          title: "Upload",
          disabled: !projectBondFiles.length,
          onClick: () => {
            handleProjectBondUploadModalClose();
            setLastUploadedFile([]);
          },
        }}
        visible={isProjectBondUploadModalOpen}
        onCancel={() => {
          handleOnCancel(
            setIsProjectBondUploadModalOpen,
            projectBondFiles,
            handleProjectBondFileChange
          );
        }}
        width={"761px"}
        title={projectBondHeader}
        className={styles.modalWrapper}
      >
        <InternalApprovalUploadDragger
          handleFileUpload={handleProjectBondFileChange}
          fileType={"Bond Information"}
          listOfUploadedFiles={projectBondFiles}
          maxFileSize={6}
          allowedFileTypes={fileTypePermissions}
          handleDeleteDocument={handleDeleteDocument}
          setLastUploadedFile={setLastUploadedFile}
        />
      </Modal>
      <Modal
        okButtonProps={{
          title: "Upload",
          disabled: !projectInfoSectionFiles.length,
          onClick: () => {
            setIsProjectInfoSectionUploadModalOpen(false);
            setLastUploadedFile([]);
          },
        }}
        visible={isProjectInfroSectionUploadModalOpen}
        onCancel={() => {
          handleOnCancel(
            setIsProjectInfoSectionUploadModalOpen,
            projectInfoSectionFiles,
            setProjectInfoSectionFiles
          );
        }}
        width={"761px"}
        title={projectInfoSectionHeader}
        className={styles.modalWrapper}
      >
        <InternalApprovalUploadDragger
          handleFileUpload={setProjectInfoSectionFiles}
          fileType={"Project Info Section"}
          listOfUploadedFiles={projectInfoSectionFiles}
          maxFileSize={6}
          allowedFileTypes={fileTypePermissions}
          handleDeleteDocument={handleDeleteDocument}
          setLastUploadedFile={setLastUploadedFile}
        />
      </Modal>
      <Modal
        okButtonProps={{
          title: "Upload",
          disabled: !propertyLegalDescriptionFiles.length,
          onClick: () => {
            setIsPropertyLegalDescriptionUploadModalOpen(false);
            setLastUploadedFile([]);
          },
        }}
        visible={isPropertyLegalDescriptionUploadModalOpen}
        onCancel={() => {
          handleOnCancel(
            setIsPropertyLegalDescriptionUploadModalOpen,
            propertyLegalDescriptionFiles,
            setPropertyLegalDescriptionFiles
          );
        }}
        width={"761px"}
        title={propertyLegalDescriptionHeader}
        className={styles.modalWrapper}
      >
        <InternalApprovalUploadDragger
          handleFileUpload={setPropertyLegalDescriptionFiles}
          fileType={"Property Legal Description"}
          listOfUploadedFiles={propertyLegalDescriptionFiles}
          maxFileSize={6}
          allowedFileTypes={fileTypePermissions}
          handleDeleteDocument={handleDeleteDocument}
          setLastUploadedFile={setLastUploadedFile}
        />
      </Modal>
      <Modal
        okButtonProps={{
          title: "Upload",
          disabled: !propertyOwnerInformationFiles.length,
          onClick: () => {
            setIsPropertyOwnerInformationUploadModalOpen(false);
            setLastUploadedFile([]);
          },
        }}
        visible={isPropertyOwnerInformationUploadModalOpen}
        onCancel={() => {
          handleOnCancel(
            setIsPropertyOwnerInformationUploadModalOpen,
            propertyOwnerInformationFiles,
            setPropertyOwnerInformationFiles
          );
        }}
        width={"761px"}
        title={propertyOwnerInformationHeader}
        className={styles.modalWrapper}
      >
        <InternalApprovalUploadDragger
          handleFileUpload={setPropertyOwnerInformationFiles}
          fileType={"Property Owner Information"}
          listOfUploadedFiles={propertyOwnerInformationFiles}
          maxFileSize={6}
          allowedFileTypes={fileTypePermissions}
          handleDeleteDocument={handleDeleteDocument}
          setLastUploadedFile={setLastUploadedFile}
        />
      </Modal>
      <Modal
        okButtonProps={{
          title: "Upload",
          disabled: !generalContractorInformationFiles.length,
          onClick: () => {
            setIsGeneralContractorInformationUploadModalOpen(false);
            setLastUploadedFile([]);
          },
        }}
        visible={isGeneralContractorInformationUploadModalOpen}
        onCancel={() => {
          handleOnCancel(
            setIsGeneralContractorInformationUploadModalOpen,
            generalContractorInformationFiles,
            setGeneralContractorInformationFiles
          );
        }}
        width={"761px"}
        title={generalOwnerInformationHeader}
        className={styles.modalWrapper}
      >
        <InternalApprovalUploadDragger
          handleFileUpload={setGeneralContractorInformationFiles}
          fileType={"General Contractor Information"}
          listOfUploadedFiles={generalContractorInformationFiles}
          maxFileSize={6}
          allowedFileTypes={fileTypePermissions}
          handleDeleteDocument={handleDeleteDocument}
          setLastUploadedFile={setLastUploadedFile}
        />
      </Modal>
      <Modal
        okButtonProps={{
          title: "Upload",
          disabled: !subcontractorInformationFiles.length,
          onClick: () => {
            setIsSubcontractorInformationUploadModalOpen(false);
            setLastUploadedFile([]);
          },
        }}
        visible={isSubcontractorInformationUploadModalOpen}
        onCancel={() => {
          handleOnCancel(
            setIsSubcontractorInformationUploadModalOpen,
            subcontractorInformationFiles,
            setSubcontractorInformationFiles
          );
        }}
        width={"761px"}
        title={subContractorOwnerHeader}
        className={styles.modalWrapper}
      >
        <InternalApprovalUploadDragger
          handleFileUpload={setSubcontractorInformationFiles}
          fileType={"Subcontractor Information"}
          listOfUploadedFiles={subcontractorInformationFiles}
          maxFileSize={6}
          allowedFileTypes={fileTypePermissions}
          handleDeleteDocument={handleDeleteDocument}
          setLastUploadedFile={setLastUploadedFile}
        />
      </Modal>
      <div className={styles.TopContainer}>
        <div className={styles.SubHeader}>{projectDetailsHeader}</div>
        <div className={styles.DropDownContent}>
          We are a
          {
            <CustomRenderSelectField
              items={dropDown1Items}
              setItems={setDropDown1Items}
              name={dropDown1InputName}
              setName={setDropDown1InputName}
              placeholder="Choose"
              nameAttr="dropdown1"
              value={dropdown1Value}
              isErrorMsg
            />
          }
          contractor to the
          {
            <CustomRenderSelectField
              items={dropDown2Items}
              setItems={setDropDown2Items}
              name={dropDown2InputName}
              setName={setDropDown2InputName}
              placeholder="Choose"
              nameAttr="dropdown2"
              value={dropdown2Value}
              isErrorMsg
            />
          }
          on a
          {
            <CustomRenderSelectField
              items={dropDown3Items}
              setItems={setDropDown3Items}
              name={dropDown3InputName}
              setName={setDropDown3InputName}
              placeholder="Choose"
              nameAttr="dropdown3"
              value={dropdown3Value}
              isErrorMsg
            />
          }
          project
        </div>
        <div className={styles.SubHeader}>{onSiteContactHeader}</div>
        <div className={styles.ContactContainer}>
          <Row>
            {onSiteContactFields?.map((inputField) => {
              return (
                <Col span={8}>
                  <InputField
                    type={inputField?.type}
                    name={inputField?.name}
                    placeholder={inputField?.placeholder}
                    label={inputField?.label}
                    requiredField={inputField?.requiredField}
                    {...(inputField.name === "onSiteContactPhone"
                      ? {
                          onChange: (e) => {
                            setValue(
                              "onSiteContactPhone",
                              formatPhoneNumber(e)
                            );
                            clearErrors("onSiteContactPhone");
                          },
                        }
                      : {})}
                  />
                </Col>
              );
            })}
          </Row>
        </div>
        <div className={styles.SubHeader}>{projectCoordinatesHeader}</div>
        <div className={styles.ContactContainer}>
          <Row>
            {projectCoordinateFields?.map((inputFields) => {
              return (
                <Col span={8}>
                  <ConditionalRender
                    visible={inputFields?.type === InputfieldTypes.GOOGLE}
                  >
                    <TNGoogleAddressSuggestions
                      name={inputFields?.name}
                      label={inputFields?.label}
                      placeholder={inputFields?.placeholder}
                      isJobSiteAddress={inputFields?.isJobSiteAddress}
                      requiredField={inputFields?.requiredField}
                    />
                  </ConditionalRender>
                  <ConditionalRender
                    visible={inputFields?.type === InputfieldTypes.TEXT}
                  >
                    <div className={styles.jobSiteCoordWrapper}>
                      <InputField
                        type={inputFields?.type}
                        name={inputFields?.name}
                        placeholder={inputFields?.placeholder}
                        label={inputFields?.label}
                        onBlur={() => {
                          if (locationData?.data?.formattedAddress) {
                            setValue(
                              "jobSiteAddress",
                              locationData?.data?.formattedAddress
                            );
                          }
                        }}
                      />
                    </div>
                  </ConditionalRender>
                </Col>
              );
            })}
            <Col span={8}></Col>
          </Row>
        </div>
        <div className={styles.SubHeader}>
          {PROJECT_BOND_STATUS_SUBHEADING}
        </div>
        <div className={styles.BondContainer}>
          <Row>
            <Col span={4}>
              <RadioComponent
                name={projectBondButton}
                options={[
                  {
                    label: BondStatusLabel.bonded,
                    value: BondStatusValue.bonded,
                  },
                  {
                    label: BondStatusLabel.notBonded,
                    value: BondStatusValue.notBonded,
                  },
                ]}
                value={bondStatus}
                onChange={handleBondStatusChange}
              />
            </Col>
            <ConditionalRender visible={bondStatus === BondStatusValue.bonded}>
              <Col span={5}>
                <TNButton
                  type={ButtonType.PRIMARY}
                  text={uploadButtonTitle}
                  shape={ButtonShape.DEFAULT}
                  onClick={() => setBondInfoDocumentUploadModalOpen(true)}
                />
              </Col>
              <Col span={4}>
                {bondInfoDocumentFiles?.map((file, index) => (
                  <ConditionalRender visible={file?.name}>
                    <div key={index} className={styles.FileName}>
                      <img
                        src={iconMapping[file?.fileType] || fileIcon}
                        alt={pdfAltText}
                        className={styles.PdfIcon_ProjectBond}
                      />{" "}
                      {file?.name}
                    </div>
                  </ConditionalRender>
                ))}
              </Col>
            </ConditionalRender>
          </Row>
        </div>
        <div className={styles.SubHeader}>
          {customerApprovalAggrementHeader}
        </div>
        <div className={styles.CustomerAggrementContainer}>
          {filteredDocuments?.map((doc, index) => (
            <div key={index} className={styles.FileName}>
              <img
                src={pdfIcon}
                alt={pdfAltText}
                className={styles.PdfIcon_CustomerApproval}
              />{" "}
              {doc?.name}
            </div>
          ))}
        </div>
        <div className={styles.SubHeader}>{taxExemptDocumentHeader}</div>
        <div className={styles.BondContainer}>
          <Row>
            <Col span={4}>
              <RadioComponent
                name={taxExemptButton}
                options={taxExemptRadioOptions}
                value={taxExempt}
                onChange={handleTaxStatusChange}
              />
            </Col>
            <ConditionalRender
              visible={taxExempt === taxExemptStatusValue.exempt}
            >
              <Col span={5}>
                <TNButton
                  type={ButtonType.PRIMARY}
                  text={uploadButtonTitle}
                  shape={ButtonShape.DEFAULT}
                  onClick={handleTaxExemptDocumentModalOpen}
                />
              </Col>
              <Col span={4}>
                {taxExemptDocumentFiles?.map((file, index) => (
                  <ConditionalRender visible={file?.name}>
                    <div key={index} className={styles.FileName}>
                      <img
                        src={
                          iconMapping[file?.type] ??
                          (iconMapping[file?.fileType] || fileIcon)
                        }
                        alt={pdfAltText}
                        className={styles.PdfIcon_ProjectBond}
                      />{" "}
                      {file?.name}
                    </div>
                  </ConditionalRender>
                ))}
              </Col>
            </ConditionalRender>
          </Row>
        </div>
        <div className={styles.SubHeader}>
          {invoiceNotesHeader} <span>{invoiceNotesSubHeader}</span>
        </div>
        <div className={styles.NoteContainer}>
          {invoiceNotesFields?.map((field) => (
            <InputField
              type={field.type}
              name={field.name}
              placeholder={field.placeHolder}
              maxLength={field.maxLength}
              showCount={field.showCount}
              textAreaRows={field.rows}
              noResize={true}
            />
          ))}
        </div>
        <div className={styles.WarningContent}>{warningContent}</div>
      </div>
      <div className={styles.BottomContainer}>
        <div className={styles.BottomContainer_Header}>
          <div className={styles.SubHeader}>
            {cashOrCreditStatus 
              ? cashOrCreditSaleHeader
              : overallProjectInformationSheetHeader
            }
          </div>
          <ConditionalRender
            visible={!!!cashOrCreditStatus}
          >
            <TNButton
              type={ButtonType.PRIMARY}
              text={uploadButtonTitle}
              shape={ButtonShape.DEFAULT}
              onClick={handleProjectInformationSheetModalOpen}
            />
            <ConditionalRender
              visible={projectInformationSheetFiles.length}
              fallback={
                <h3 className={styles.noProjectInfo}>
                  {noProjectInformationSheet}
                </h3>
              }
            >
              <img
                src={
                  iconMapping[projectInformationSheetFiles[0]?.type] ??
                  (iconMapping[projectInformationSheetFiles[0]?.fileType] ||
                    fileIcon)
                }
                alt={pdfAltText}
                className={styles.PdfIcon_ProjectInformationSheet}
              />{" "}
              {projectInformationSheetFiles[0]?.name}
              <img
                src={deleteIcon}
                className={styles.DeleteIcon_SubSection}
                alt="Delete Icon"
                onClick={() => {
                  handleSubSectionDocumentDelete(
                    projectInformationSheetFiles[0],
                    projectInformationSheetFiles,
                    setProjectInformationSheetFiles,
                    0
                  );
                }}
              />
              <span>
                {" "}
                <Tag
                  className={clsx({
                    [styles.CustomTag_Approved]:
                      getOverallApprovalStatus() === SectionStatus.APPROVED,
                    [styles.CustomTag_Rejected]:
                      getOverallApprovalStatus() === SectionStatus.REJECTED,
                    [styles.CustomTag_Pending]:
                      getOverallApprovalStatus() === SectionStatus.PENDING,
                  })}
                >
                  {getOverallApprovalStatus()}
                </Tag>
              </span>
            </ConditionalRender>
          </ConditionalRender>
          <div className={styles.toggleContainer}>
            <div className={styles.toggleLabel}>Cash/Credit sales</div>
            <InputField
              name={cashOrCreditSale}
              value={cashOrCreditStatus}
              defaultChecked={cashOrCreditStatus}
              type={InputfieldTypes.SWITCH}
            />
          </div>
        </div>
        <div className={styles.BottomContainer_Sections}>
          <ConditionalRender
            visible={!!!cashOrCreditStatus}
          >
            <div className={styles.ThreeColumnContainer}>
              <div className={styles.FixedLeftColumn}>
                {subSections.map((item, index) => (
                  <div
                    key={index}
                    className={clsx({
                      [styles.SubSection_active]: selectedRow === index,
                      [styles.SubSection_Inactive]: selectedRow !== index,
                      [styles.LastRow]: index === subSections.length - 1,
                    })}
                    onClick={() => setSelectedRow(index)}
                  >
                    <div className={styles.LeftItem}>
                      {item}{" "}
                      <Tag
                        key={index}
                        className={clsx({
                          [styles.CustomTag_Approved]:
                            approvalDocuments[item]?.status ===
                              SectionStatus.L1_APPROVED ||
                            approvalDocuments[item]?.status ===
                              SectionStatus.L2_APPROVED,
                          [styles.CustomTag_Rejected]:
                            approvalDocuments[item]?.status ===
                              SectionStatus.L1_REJECTED ||
                            approvalDocuments[item]?.status ===
                              SectionStatus.L2_REJECTED,
                          [styles.CustomTag_Pending]:
                            !approvalDocuments ||
                            approvalDocuments[item]?.status ===
                              SectionStatus.PENDING ||
                            internalApprovalBeforeStates?.includes(
                              jobData?.stageId
                            ),
                        })}
                      >
                        {internalApprovalBeforeStates?.includes(jobData?.stageId)
                          ? SectionStatus.PENDING
                          : approvalDocuments[item]?.status}
                      </Tag>
                    </div>
                    <div className={styles.RightItem}>
                      <ConditionalRender
                        visible={
                          (approvalDocuments[item]?.status ===
                            SectionStatus.L1_REJECTED ||
                            approvalDocuments[item]?.status ===
                              SectionStatus.L2_REJECTED) &&
                          !internalApprovalBeforeStates?.includes(
                            jobData?.stageId
                          )
                        }
                      >
                        <Popover
                          content={
                            approvalDocuments[item]?.review?.find(
                              (r) => r.status === SectionStatus.REJECTED
                            )?.reasonForRejection
                          }
                          trigger="hover"
                          overlayClassName={styles.PopoverContainer}
                          placement={PlacementPositions.RIGHT_BOTTOM}
                        >
                          <img
                            src={popOverIcon}
                            alt="info"
                            className={styles.PopOverImg}
                          />
                        </Popover>
                      </ConditionalRender>
                    </div>
                  </div>
                ))}
              </div>

              <div
                className={clsx(styles.FlexibleMiddleColumn, styles.PdfSection)}
              >
                {selectedRow === 0 && (
                  <div>
                    {projectInfoSectionFiles.map((file, index) => (
                      <div key={index} className={styles.SubSection_FileNames}>
                        <img
                          src={iconMapping[file?.fileType] || fileIcon}
                          alt={pdfAltText}
                          className={styles.PdfIcon_SubSection}
                        />{" "}
                        {file.name}
                        <img
                          src={deleteIcon}
                          className={styles.DeleteIcon_SubSection}
                          alt="Delete Icon"
                          onClick={() => {
                            handleSubSectionDocumentDelete(
                              file,
                              projectInfoSectionFiles,
                              setProjectInfoSectionFiles,
                              index
                            );
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}
                {selectedRow === 1 && (
                  <div>
                    {propertyLegalDescriptionFiles.map((file, index) => (
                      <div key={index} className={styles.SubSection_FileNames}>
                        <img
                          src={iconMapping[file?.fileType] || fileIcon}
                          alt={pdfAltText}
                          className={styles.PdfIcon_SubSection}
                        />{" "}
                        {file.name}
                        <img
                          src={deleteIcon}
                          className={styles.DeleteIcon_SubSection}
                          alt="Delete Icon"
                          onClick={() => {
                            handleSubSectionDocumentDelete(
                              file,
                              propertyLegalDescriptionFiles,
                              setPropertyLegalDescriptionFiles,
                              index
                            );
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}
                {selectedRow === 2 && (
                  <div>
                    {propertyOwnerInformationFiles.map((file, index) => (
                      <div key={index} className={styles.SubSection_FileNames}>
                        <img
                          src={iconMapping[file?.fileType] || fileIcon}
                          alt={pdfAltText}
                          className={styles.PdfIcon_SubSection}
                        />{" "}
                        {file.name}
                        <img
                          src={deleteIcon}
                          className={styles.DeleteIcon_SubSection}
                          alt="Delete Icon"
                          onClick={() => {
                            handleSubSectionDocumentDelete(
                              file,
                              propertyOwnerInformationFiles,
                              setPropertyOwnerInformationFiles,
                              index
                            );
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}
                {selectedRow === 3 && (
                  <div>
                    {generalContractorInformationFiles.map((file, index) => (
                      <div key={index} className={styles.SubSection_FileNames}>
                        <img
                          src={iconMapping[file?.fileType] || fileIcon}
                          alt={pdfAltText}
                          className={styles.PdfIcon_SubSection}
                        />{" "}
                        {file.name}
                        <img
                          src={deleteIcon}
                          className={styles.DeleteIcon_SubSection}
                          alt="Delete Icon"
                          onClick={() => {
                            handleSubSectionDocumentDelete(
                              file,
                              generalContractorInformationFiles,
                              setGeneralContractorInformationFiles,
                              index
                            );
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}
                {selectedRow === 4 && (
                  <div>
                    {subcontractorInformationFiles.map((file, index) => (
                      <div key={index} className={styles.SubSection_FileNames}>
                        <img
                          src={iconMapping[file?.fileType] || fileIcon}
                          alt={pdfAltText}
                          className={styles.PdfIcon_SubSection}
                        />{" "}
                        {file.name}
                        <img
                          src={deleteIcon}
                          className={styles.DeleteIcon_SubSection}
                          alt="Delete Icon"
                          onClick={() => {
                            handleSubSectionDocumentDelete(
                              file,
                              subcontractorInformationFiles,
                              setSubcontractorInformationFiles,
                              index
                            );
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}
                {selectedRow === 5 && (
                  <div>
                    {projectBondFiles.map((file, index) => (
                      <div key={index} className={styles.SubSection_FileNames}>
                        <img
                          src={iconMapping[file?.fileType] || fileIcon}
                          alt={pdfAltText}
                          className={styles.PdfIcon_SubSection}
                        />{" "}
                        {file.name}
                        <img
                          src={deleteIcon}
                          className={styles.DeleteIcon_SubSection}
                          alt="Delete Icon"
                          onClick={async () => {
                            await handleSubSectionDocumentDelete(
                              file,
                              projectBondFiles,
                              setProjectBondFiles,
                              index
                            );
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className={styles.FixedRightColumn}>
                <TNButton
                  type={ButtonType.PRIMARY}
                  text={uploadButtonTitle}
                  shape={ButtonShape.DEFAULT}
                  className={styles.SubSection_UploadButton}
                  onClick={() => {
                    switch (selectedRow) {
                      case 0:
                        setIsProjectInfoSectionUploadModalOpen(true);
                        break;
                      case 1:
                        setIsPropertyLegalDescriptionUploadModalOpen(true);
                        break;
                      case 2:
                        setIsPropertyOwnerInformationUploadModalOpen(true);
                        break;
                      case 3:
                        setIsGeneralContractorInformationUploadModalOpen(true);
                        break;
                      case 4:
                        setIsSubcontractorInformationUploadModalOpen(true);
                        break;
                      case 5:
                        setIsProjectBondUploadModalOpen(true);
                        break;
                      default:
                        break;
                    }
                  }}
                />
              </div>
            </div>
          </ConditionalRender>
          <ConditionalRender
            visible={cashOrCreditStatus}
          >
            <div className={styles.cashOrCreditUploadContainer}>
              <InternalApprovalUploadDragger
                handleFileUpload={handleCashOrCreditFileChange}
                listOfUploadedFiles={cashOrCreditDocs}
                fileType={DocTypes.CASH_CREDIT_SALE_DOCUMENTS}
                maxFileSize={6}
                allowedFileTypes={fileTypePermissions}
                handleDeleteDocument={handleDeleteDocument}
                setLastUploadedFile={setLastUploadedFile}
                cashOrCreditUpload={true}
              />
            </div>
          </ConditionalRender>
        </div>{" "}
      </div>
    </>
  );
};

export default InternalApproval;
